// extracted by mini-css-extract-plugin
export default {"recentSalesWrapper":"SocialProof__recentSalesWrapper-O4TE"};